import { createSlice } from '@reduxjs/toolkit'
import { OrganizationsState } from './organizations.interface'
import {
  editOrganization,
  getCurrentUserOrganization,
  getOrganizationById,
  getOrganizationLicenses,
  getOrganizationUsers,
  getOrganizations
} from '@/store/actions/organizations.actions'

const initialState: OrganizationsState = {
  organizations: {
    organizations: [],
    totalCount: 0
  },
  orgLicenses: [],
  orgUsers: [],
  organization: undefined,
  organizationsError: null
}

const organizationsSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    setOrganizations(state, action) {
      state.organizations = action.payload
    },
    setOrganization(state, action) {
      state.organization = action.payload
    },
    setOrganizationsError(state, action) {
      state.organizationsError = action.payload
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getOrganizations.fulfilled, (state, action) => {
        state.organizations = action.payload
      })
      .addCase(getCurrentUserOrganization.fulfilled, (state, action) => {
        state.organization = action.payload
      })
      .addCase(getOrganizationById.fulfilled, (state, action) => {
        state.organization = action.payload
      })
      .addCase(editOrganization.fulfilled, (state, action) => {
        const organizationIndex = state.organizations.organizations.findIndex((org) => org.id === action.payload.id)
        state.organizations.organizations[organizationIndex] = action.payload
        state.organization = action.payload
      })
      .addCase(getOrganizationLicenses.fulfilled, (state, action) => {
        state.orgLicenses = action.payload
      })
      .addCase(getOrganizationUsers.fulfilled, (state, action) => {
        state.orgUsers = action.payload
      })
  }
})

export const { setOrganization, setOrganizations, setOrganizationsError } = organizationsSlice.actions

export default organizationsSlice.reducer
